import { toEnumValue } from '$lib/shared/enums';
import { getLocale, LocaleId, newIntlLocale } from '@shared/intl';

export interface NumberFormatOptions {
  localeId?: LocaleId;
  fractionDigits?: number; // Shorthand for setting min and max
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatNumber(value: number, options?: NumberFormatOptions) {
  const args = parse(options);
  const { localeId, minimumFractionDigits, maximumFractionDigits } = args;
  const intlLocale = newIntlLocale(localeId);

  const formatter = new Intl.NumberFormat(intlLocale, { minimumFractionDigits, maximumFractionDigits });
  return formatter.format(value);
}

export function formatCurrency(value: number, options?: NumberFormatOptions) {
  const args = parse(options);
  const { localeId, minimumFractionDigits, maximumFractionDigits } = args;
  const locale = getLocale(localeId);
  const intlLocale = newIntlLocale(localeId);

  const formatter = new Intl.NumberFormat(intlLocale, {
    style: 'currency',
    currency: locale.currencyCode,
    minimumFractionDigits,
    maximumFractionDigits,
  });
  return formatter.format(value);
}

function parse(options: NumberFormatOptions | undefined) {
  return {
    ...options,
    localeId:
      options?.localeId ??
      toEnumValue(LocaleId, navigator.language, { ignoreCase: true }) ??
      LocaleId.EnglishUnitedStates,
    minimumFractionDigits: options?.minimumFractionDigits ?? options?.fractionDigits,
    maximumFractionDigits: options?.maximumFractionDigits ?? options?.fractionDigits,
  };
}
